module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/1/3-a64941ddd807415cd0f43a33d56e45a9.jpg";